import script from "./NotificationActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationActions.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationActions.vue?vue&type=style&index=0&id=0c2756a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2756a8"]])

export default __exports__